import styled from 'styled-components'

export const ActionsContainer = styled.div`
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  margin-top: ${props => props.theme.spacing.sp16};
`
